import type { FileRecord } from "@cohesive/api-client";

/**
 * @deprecated Remove when all legacy `base: "image" | "video" | "file"`
 * entities are migrated to `base: "file_record"`.
 *
 * Synthesizes a `FileRecord`-shaped object from a legacy entity's `data`
 * payload so we can render every file-ish entity through a single
 * `FileRecordCard`. Pure — no hooks, no fetches; just data reshape.
 */
export function legacyFileEntityDataToFileRecord(
  base: "image" | "video" | "file",
  data: Record<string, unknown>,
): FileRecord {
  const now = new Date().toISOString();

  const title =
    (typeof data.title === "string" && data.title) ||
    (typeof data.name === "string" && data.name) ||
    (base === "image" ? "image" : base === "video" ? "video" : "file");

  const url =
    (typeof data.web_link === "string" && data.web_link) ||
    (typeof data.url === "string" && data.url) ||
    (typeof data.thumbnail_link === "string" && data.thumbnail_link) ||
    undefined;

  const defaultMime =
    base === "image"
      ? "image/png"
      : base === "video"
        ? "video/mp4"
        : "application/octet-stream";
  const contentType =
    (typeof data.mime_type === "string" && data.mime_type) ||
    (typeof data.content_type === "string" && data.content_type) ||
    defaultMime;

  const size =
    typeof data.size === "number"
      ? data.size
      : typeof data.size === "string"
        ? parseInt(data.size, 10) || 0
        : 0;

  const width = typeof data.width === "number" ? data.width : undefined;
  const height = typeof data.height === "number" ? data.height : undefined;
  const generation_prompt =
    typeof data.prompt === "string" && data.prompt.length > 0
      ? data.prompt
      : undefined;

  const previewUrlsRaw = data.preview_urls;
  const preview_urls =
    previewUrlsRaw &&
    typeof previewUrlsRaw === "object" &&
    previewUrlsRaw !== null &&
    !Array.isArray(previewUrlsRaw)
      ? (previewUrlsRaw as Record<string, string>)
      : undefined;

  return {
    id: typeof data.id === "string" ? data.id : `legacy-${base}`,
    organization_id: "",
    provider: "s3",
    provider_id: "",
    status:
      (typeof data.status === "string" &&
        (data.status as FileRecord["status"])) ||
      "processed",
    class: "workspace",
    path: `/${title}`,
    content_type: contentType,
    content_hash: "",
    size,
    ...(width !== undefined ? { width } : {}),
    ...(height !== undefined ? { height } : {}),
    ...(generation_prompt ? { generation_prompt } : {}),
    url,
    ...(preview_urls ? { preview_urls } : {}),
    created_at: typeof data.created_at === "string" ? data.created_at : now,
    updated_at: typeof data.updated_at === "string" ? data.updated_at : now,
  };
}
